'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userHeader = require('./components/user-header');

Object.defineProperty(exports, 'UserHeader', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_userHeader).default;
  }
});

var _userHeaderActions = require('./components/user-header-actions');

Object.defineProperty(exports, 'UserHeaderActions', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_userHeaderActions).default;
  }
});

var _userHeaderNav = require('./components/user-header-nav');

Object.defineProperty(exports, 'UserHeaderNav', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_userHeaderNav).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-header/lib/index.js
// module id = 1557
// module chunks = 1